import Footer from "../../footer"
import NavBar from "../../nav"

const PilotTraining = () => {
  return <div className='pilot-training'>
    <NavBar />
    <div>
    <section className="clean-block pfa-content clearfix">
			<div className="divider sections">
				<h1>Pilot Training</h1>
				<div className="headline-divider sections"></div>
				<h2>Aviation Syllabus &amp; Curriculum</h2>
			</div>
		</section>
    <section className="grid-links-container row">
			<div className="container my-5">
				<div className="row">
					<div className="col-12 col-md-4 d-flex">
						<a href="/training/standardized-training" className="grid-links grow text-center">
							<h3>Standardized Training</h3>
							<p>5 Core Training Modules <br /> High Level Training Summary</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex my-3 my-md-0">
						<a href="/training/international-training" className="grid-links grow text-center">
							<h3>International Training</h3>
							<p>Latest Guidance. Best Operating Practices. <br /> Our International Training Process.</p>
						</a>
					</div>
					<div className="col-12 col-md-4 d-flex">
						<a href="/training/understanding-the-why-in-135" className="grid-links grow text-center">
							<h3>Compliance Seminar</h3>
							<p>Learn About The Next Fly Compliance Seminar's</p>
						</a>
					</div>
				</div>
			</div>
		</section>
    </div>
    <Footer />
  </div>
}

export default PilotTraining